import { getCalculatorLocalStorage } from '@thd-olt-component-react/calculator';

export const configuratorHasRooms = (url) => {
  const regex = /[?&](rooms|item)=/i;
  return regex.test(url);
};

export const getRoomsFromPIP = () => {
  const obj = getCalculatorLocalStorage({
    classInfo: {
      productDepartment: '23',
      classNumber: '15'
    }
  });
  const { storageObj } = obj;
  if (storageObj?.areas) {
    return storageObj.areas
      .filter((x) => +x.length > 0 && +x.width > 0)
      .map((x) => ({ ...x, room: x.name }));
  }
  return [];
};
